import React from 'react';
import AuditFormChild from '../AuditFormChild';
// import * as _ from 'lodash';
import slug from 'constants/slug';
import { getOneAuditDetail, updateOneAuditDetail } from 'api/facilityAuditApi';
import Message from 'rc-message';
import PageLockHOC from 'hoc/pageLock';

@PageLockHOC(['facilityAudit.write'])
export default class AuditEditChild extends React.Component {
  static propTypes = {};

  state = {
    _idObject: '',
    isLoading: true,
    initialValue: null,
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');
    if (_id) {
      const res = await getOneAuditDetail(_id);
      if (res.success) {
        this.setState({
          _idObject: _id,
          isLoading: false,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.AUDIT.LIST);
    }
  }

  async componentWillMount() {
    await this.checkValidate();
  }

  getId() {
    const _id = _.result(this.props, 'match.params._id');
    return _id;
  }

  getParentId() {
    const parentId = _.result(this.props, 'match.params.parentId');
    return parentId;
  }

  handelSubmit = async (values) => {
    this.setState({
      isLoading: true,
    });

    const res = await updateOneAuditDetail(this.state._idObject, values);
    if (res.success) {
      Message.success({ content: 'Sửa Thành Công' });
      this.props.history.push(
        `${slug.AUDIT.VIEW_WITH_ID_CHILD}${this.getId()}/${this.getParentId()}`
      );
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return (
      <div>
        {!this.state.isLoading && (
          <div>
            <AuditFormChild
              isEdit={true}
              initialValue={this.state.initialValue}
              onSubmit={this.handelSubmit}
              slugBack={slug.AUDIT.LIST}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FacilityAudit/AuditEditChild/index.js